import createCachedSelector from 're-reselect';

import { ClientSharePointWebLinkDetail, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';

export const findById = createFindById<ClientSharePointWebLinkDetail>('clientSharePointWebLinkDetails');
export const findByIdThrows = createFindByIdThrows<ClientSharePointWebLinkDetail>('clientSharePointWebLinkDetails');

type GetFulfilledClientSharePointWebLinkDetails = (state: YammerState) => Record<string, ClientSharePointWebLinkDetail>;
export const getFulfilledClientSharePointWebLinkDetails: GetFulfilledClientSharePointWebLinkDetails = (state) =>
  state.clientSharePointWebLinkDetails.fulfilled.byId;

const getRejectedClientSharePointWebLinkDetails = (state: YammerState) =>
  state.clientSharePointWebLinkDetails.rejected.byId;

type GetRejectedClientSharePointWebLinkDetailsIds = (state: YammerState) => ClientSharePointWebLinkDetail['id'][];
export const getRejectedClientSharePointWebLinkDetailsIds: GetRejectedClientSharePointWebLinkDetailsIds =
  createCachedSelector(getRejectedClientSharePointWebLinkDetails, (rejectedClientSharePointWebLinkDetails) =>
    Object.keys(rejectedClientSharePointWebLinkDetails)
  )((_state) => 'cache');
